import React, { FunctionComponent } from "react";
import { Link } from "@Lib/router";

const HomePage: FunctionComponent = () => {
  return (
    <div className="HomePage">
      <Link href={`/customizations/123/edit`}>my content</Link>
    </div>
  );
};

export default HomePage;
